exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-blue[data-v-41dab38a]{color:#1b88c1}.color-orange[data-v-41dab38a]{color:#ff6305}", ""]);

// exports
